"use strict";
/**
 * Copyright 2017-present Palantir Technologies, Inc. All rights reserved.
 * Licensed under the BSD-3 License as modified (the “License”); you may obtain
 * a copy of the license in the LICENSE and PATENTS files in the root of this
 * repository.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Splits the `text` string into words and invokes the `callback` for each word that is
 * found in the `data` record. If not found, the word appears unchanged in the output
 * array.
 *
 * Example:
 * ```tsx
 * linkify("string | ITag", docs.typescript, (name) => <a href={`#api/${name}`}>{name}</a>)
 * // =>
 * ["string", " | ", <a href="#api/ITag">ITag</a>]
 * ```
 */
function linkify(text, data, callback) {
    return text
        .split(WORD_SEPARATORS)
        .map(function (word, idx) { return (data[word] == null ? word : callback(word, data[word], idx)); });
}
exports.linkify = linkify;
var WORD_SEPARATORS = /([\[\]<>()| :.,]+)/g;
/**
 * Slugify a string: "Really Cool Heading!" => "really-cool-heading-"
 */
function slugify(str) {
    return str.toLowerCase().replace(/[^\w.\/]/g, "-");
}
exports.slugify = slugify;



//////////////////
// WEBPACK FOOTER
// ./node_modules/documentalist/dist/client/utils.js
// module id = 1305
// module chunks = 0